import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";

const state = {
    summary:{
        morningClosing: null,
        morningTotal: null,
        morningRemarks: null,
        eveningClosing: null,
        eveningTotal: null,
        eveningRemarks: null,  
        createdBy: null,  
        createdOn: null,  
        updatedBy: null,  
        updatedOn: null,  
    }  
};
const getters = {
};
const mutations = {
    UPDATE: (state, updateData ) => state.summary = updateData,
};
const actions = {
    async getAll({ commit}) {
        startLoading()
        try {
            const response = await dataService.workDaysClosing.getAll();
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            if(response.data.summary != null)
            {

                commit('UPDATE',  response.data.summary );
            }


    } catch(error) {
        stopLoading()
        catchHandler(error);
    }
},
   async getSummary(_,period) {
        startLoading()
        try {
            const response = await dataService.workDaysClosing.getSummary(period);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data);
          

    } catch(error) {
        stopLoading()
        catchHandler(error);
    }
},

    async add({ commit}, payload ) {
        startLoading()
        try {
            const response = await dataService.workDaysClosing.add(payload);
            stopLoading();
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            commit('UPDATE',  response.data.summary );

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);

        }
    },
   
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
